// extracted by mini-css-extract-plugin
module.exports = {"acceptCookies":"styles_acceptCookies__3oeQe","wrapper":"styles_wrapper__IIlwu","message":"styles_message__3XuXM","spin":"styles_spin__1gYJ3"};